import { getPlanCmsDetail } from '@/service';

export default {
  namespace: 'quote',
  state: {
    planCmsDetail: {},
  },
  reducers: {
    setData(state: QuoteState, { payload }: PayloadType) {
      return {
        ...state,
        ...payload,
      };
    },
  },
  effects: {
    *getPlanCmsDetail({ payload }: PayloadType, { call, put }: any): any {
      const res: any = yield call(getPlanCmsDetail, payload);
      yield put({
        type: 'setData',
        payload: {
          planCmsDetail: res,
        },
      });
    },
  },
};
